import { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../../../services/authContext';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons'
import EditProfile from './UserInfo_EditProfile';
import ChangePassword from './UserInfo_ChangePassword';

const UserInfo = () => {
    const { logout, userProfile } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const [showEditProfileModal, setShowEditProfileModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const settingsRef = useRef(null);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();  // Call logout passed from App.jsx
        navigate('/');  // Optional: Navigate back to home or login page
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Close the menu when clicking outside of it or pressing ESC
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (settingsRef.current && !settingsRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false); // Close the menu when ESC is pressed
            }
        };

        // Add event listeners
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listeners
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    const lastLogin = localStorage.getItem('lastLogin') || sessionStorage.getItem('lastLogin');

    return (
        <div className={`userInfo component`}>
            <Row className="mb-0">
                <Col xs={12} className="d-flex align-items-center">
                    <div className="d-inline-block">
                        <div className="userInfo__imageHolder">
                            {/*<img className="userInfo__imageHolder__profileImage img-fluid" src="https://thispersondoesnotexist.com/" />*/}
                            <FontAwesomeIcon className="userInfo__imageHolder__profileImage" icon={byPrefixAndName.fas["user-tie"]} />
                        </div>
                    </div>
                    <div className="d-inline-block ms-3">
                        <div>
                            <span className="size-14">
                                Welcome back:
                            </span>
                        </div>
                        <div>
                            <span className="size-28 lh-10">
                                {userProfile.firstName} {userProfile.familyName}
                            </span>
                        </div>
                        <div>
                            <span className="size-10">
                                Last login: {new Date(lastLogin).toLocaleString('en-GB', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                })}
                            </span>
                        </div>
                    </div>

                    <div ref={settingsRef} className={`d-inline-block ms-auto userInfo__settingsControl ${isOpen ? 'open' : ''}`}>
                        <div onClick={toggleMenu} className="userInfo__settingsControl__settingsIcon">
                            <FontAwesomeIcon icon={byPrefixAndName.fas['sliders']} />
                        </div>
                        <div className="userInfo__settingsControl__settingsPanel component p-0 m-0 mt-2">
                            <ul className="text-nowrap">
                                <li className="p-2" onClick={() => setShowEditProfileModal(true)}>Edit profile</li>
                                <li className="p-2" onClick={() => setShowChangePasswordModal(true)}>Update password</li>
                                <li className="p-2" onClick={handleLogout}>Log out</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>



            <EditProfile
                show={showEditProfileModal}
                handleClose={() => setShowEditProfileModal(false)}
                userProfile={userProfile}
            />


            <ChangePassword
                show={showChangePasswordModal}
                handleClose={() => setShowChangePasswordModal(false)}
                userProfile={userProfile}
            />
        </div>
    );
};

export default UserInfo;
